import { render, staticRenderFns } from "./DealBlockerModal.vue?vue&type=template&id=1949e10c"
import script from "./DealBlockerModal.vue?vue&type=script&lang=js"
export * from "./DealBlockerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports